import { render, staticRenderFns } from "./ItemTracking.vue?vue&type=template&id=10428b0b&scoped=true&"
import script from "./ItemTracking.vue?vue&type=script&lang=js&"
export * from "./ItemTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10428b0b",
  null
  
)

export default component.exports